import { render } from "./realisasi_pad_2024.vue?vue&type=template&id=1a8c5206"
import script from "./realisasi_pad_2024.vue?vue&type=script&lang=js"
export * from "./realisasi_pad_2024.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__